var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZigZag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#4831d4",
    xmlns: "http://www.w3.org/2000/svg",
    width: "88px",
    height: "88px",
    viewBox: "0 1 88 88",
    id: "avatar-shapes",
    "data-shape": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "m 0 87.36 v 0 l 22.258 0.562 v 0 l -0.56 -22.26 v 0 l 22.258 0.56 v 0 l -0.56 -22.258 v 0 l 22.259 0.56 v 0 l -0.56 -22.257 v 0 l 22.26 0.559 v 0 l -0.56 -22.26 v 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigZag);
export default __webpack_public_path__ + "static/media/zig-zag.203982c0a94e39ff49250c1ecc1b8435.svg";
export { ForwardRef as ReactComponent };